"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutWithInventory = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const AssignationPayout_1 = require("../models/AssignationPayout");
const DriverDebt_1 = require("../models/DriverDebt");
const Payout_1 = require("../models/Payout");
const User_1 = require("../models/User");
class PayoutWithInventory {
    user;
    payout;
    assignationPayouts;
    debts;
    assignationPayoutsAmount;
    debtsAmount;
    baselessAmount;
}
exports.PayoutWithInventory = PayoutWithInventory;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => User_1.User),
    __metadata("design:type", User_1.User)
], PayoutWithInventory.prototype, "user", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Payout_1.Payout),
    __metadata("design:type", Payout_1.Payout)
], PayoutWithInventory.prototype, "payout", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => AssignationPayout_1.AssignationPayout),
    __metadata("design:type", Array)
], PayoutWithInventory.prototype, "assignationPayouts", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DriverDebt_1.DriverDebt),
    __metadata("design:type", Array)
], PayoutWithInventory.prototype, "debts", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutWithInventory.prototype, "assignationPayoutsAmount", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutWithInventory.prototype, "debtsAmount", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutWithInventory.prototype, "baselessAmount", void 0);
//# sourceMappingURL=PayoutWithInventory.js.map